import { useTranslation } from 'react-i18next'

import Alert from '@/components/Alert/Alert'

const SchoolDayPlanAlert = () => {
  const { t } = useTranslation('schoolSettings')

  return <Alert message={t('alert.regenerate-lesson-plan')} />
}

export default SchoolDayPlanAlert
